const data = {
    options: {},
    editedTask: {},
    checkedDeadlines: [],
    modalData: {}
}

const mutations = {
    SET_LEGAL_FORM_OPTIONS(state, options) {
        state.options.legalForms = options
    },
    SET_ACCOUNTING_FIRM_COMPANY_OPTIONS(state, options) {
        state.options.accountingFirmCompanies = options
    },

    SET_ACCOUNTING_FIRM_OFFICE_OPTIONS(state, options) {
        state.options.accountingFirmOffices = options
    },
    SET_ACCOUNTING_FIRM_USER_OPTIONS(state, options) {
        state.options.accountingFirmUsers = options
    },
    SET_ROLE_OPTIONS(state, options) {
        state.options.roles = options
    },
    SET_BALANCE_STEP_OPTIONS(state, options) {
        state.options.balanceSteps = options
    },
    SET_LEGAL_STEP_OPTIONS(state, options) {
        state.options.legalSteps = options
    },
    SET_NATIONALITY_OPTIONS(state, options) {
        state.options.nationalities = options
    },
    SET_COUNTRY_OPTIONS(state, options) {
        state.options.countries = options
    },
    SET_END_OF_EXERCISE_OPTIONS(state, options) {
        state.options.endsOfExercise = options
    },
    SET_COMMENT_TYPE_OPTIONS(state, options) {
        state.options.commentTypes = options
    },
    SET_BILLABLE_TIME_SHEET_OPTIONS(state, options) {
        state.options.billableTimeSheets = options
    },
    SET_CLIENT_GROUP_OPTIONS(state, options) {
        state.options.clientGroups = options
    },
    SET_EDITED_TASK(state, event) {
        state.editedTask = event
    },

    RESET_CHECKED_DEADLINES(state) {
        state.checkedDeadlines = []
    },
    ADD_DEADLINE(state, deadline) {
        state.checkedDeadlines.push(deadline)
    },
    REMOVE_DEADLINE(state, deadline) {
        state.checkedDeadlines = state.checkedDeadlines.filter(
            (item) => item !== deadline
        )
    },

    SET_MODAL_DATA(state, data) {
        state.modalData = data
    },
    RESET_MODAL_DATA(state) {
        state.modalData = {}
    }
}

const actions = {
    async getAllOptions({ commit }) {
        try {
            const response = await axios.get('/options')
            commit('SET_LEGAL_FORM_OPTIONS', response.data.legalForms)
            commit(
                'SET_ACCOUNTING_FIRM_COMPANY_OPTIONS',
                response.data.accountingFirmCompanies
            )
            commit(
                'SET_ACCOUNTING_FIRM_OFFICE_OPTIONS',
                response.data.accountingFirmOffices
            )
            commit(
                'SET_ACCOUNTING_FIRM_USER_OPTIONS',
                response.data.accountingFirmUsers
            )
            commit('SET_ROLE_OPTIONS', response.data.roles)
            commit('SET_BALANCE_STEP_OPTIONS', response.data.balanceSteps)
            commit('SET_LEGAL_STEP_OPTIONS', response.data.legalSteps)
            commit('SET_END_OF_EXERCISE_OPTIONS', response.data.endOfExercise)
            commit('SET_COUNTRY_OPTIONS', response.data.countries.data)
            commit('SET_NATIONALITY_OPTIONS', response.data.nationalities.data)
            commit('SET_COMMENT_TYPE_OPTIONS', response.data.commentTypes)
            commit(
                'SET_BILLABLE_TIME_SHEET_OPTIONS',
                response.data.billableTimeSheetOptions
            )
            commit('SET_CLIENT_GROUP_OPTIONS', response.data.clientGroups)
        } catch (error) {
            // console.log('options not loaded')
        }
    }
}

export default {
    namespaced: true,
    state: data,
    mutations,
    actions
}
